import AppDialog from "../../../components/Common/AppDialog";
import { useState } from "react";
import Label from "../../../components/Common/Label";
import Helpers from "../../../helpers/helpers";

export default function MarkSold({ open, close, handleSubmit, windowWidth, isBulkAction = false, selectedItems = [] }) {
    const [showAll, setShowAll] = useState(false);
    const itemsToShow = isBulkAction ? showAll ? selectedItems : selectedItems.slice(0, 2) : [];
    return (
        <AppDialog
            title={'Mark as Sold'}
            open={open}
            close={close}
            positiveTitle={'Mark as Sold'}
            positivePress={() => handleSubmit()}
            cancelButton={true}
            width={'40%'}
            isMobile={windowWidth <= 768}
        >
            {
                isBulkAction ?
                    <>
                        <div>Are you sure you want to mark selected {selectedItems.length} advert(s) as Sold?</div>
                        <ol style={{ paddingInline: 20, paddingBlock: 10 }}>
                            {itemsToShow?.map((item, idx) => (
                                <li key={idx} className="mb-2 ">
                                    <div className="d-flex align-items-center">
                                        {item?.make?.name || '-'} {item?.model?.model_name || ''}
                                        <Label.GeneralStatusLabel label={item?.status || '-'} list={Helpers.advertStatus} marginLeft={"10px"} />
                                    </div>
                                </li>
                            ))}
                            {selectedItems.length > 2 && (
                                <div
                                    onClick={() => setShowAll(!showAll)}
                                    className="clickable underline"
                                    style={{ marginTop: '10px' }}
                                >
                                    {showAll ? 'Show less' : 'Show more'}
                                </div>
                            )}
                        </ol>
                    </> :
                    <>
                        <div>Are you sure you want to mark this advert as Sold?</div>
                    </>
            }
            <div className="my-2">Once marked as Sold:</div>
            <ul className="subheader-2" style={{ padding: 5, paddingInline: 15 }}>
                <li className="mb-2">The advert will no longer appear on the marketplace.</li>
                <li className="mb-2">Buyers can no longer contact you via WhatsApp or inquiry.</li>
                <li className="mb-2">You can still view this advert under your Sold Listings tab.</li>
                <li className="mb-2">This action can be reversed later if the sale falls through.</li>
            </ul>
        </AppDialog>
    )
}